function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.4
}, /*#__PURE__*/React.createElement(Path, {
  stroke: "#000",
  strokeWidth: 1.5,
  d: "M29.14 1.125H2.9c-.703 0-1.275.571-1.275 1.275v17.636c0 .705.572 1.275 1.277 1.275h26.24c.704 0 1.276-.57 1.276-1.275V2.4c0-.705-.572-1.276-1.277-1.276z"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#FFF",
  d: "M1.624 17.467h28.791"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#000",
  strokeWidth: 1.5,
  d: "M1.624 17.467h28.791"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#FFF",
  d: "M18.558 21.312h-5.076l-1.5 5.075h8.076z"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#000",
  strokeWidth: 1.5,
  d: "M18.558 21.312h-5.076l-1.5 5.075h8.076z"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M8.625 26.387h14.79M11.411 12.029l5.507-5.508m-.707 5.816l2.381-2.381"
}));

function SvgIconMenuAffichage(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28
  }, props), _ref);
}

export default SvgIconMenuAffichage;